<template>
  <div class="bg-black flex p-2 rounded-xl cursor-pointer z-10" @click="onClick">
    <NuxtImg src="/flyp-logo-rounded.png" alt="Flyp logo" width="24" height="24"/>
    <div class="text-white font-semibold justify-center pl-3 pr-2">Created with FLYP</div>
  </div>
</template>

<script lang="ts" setup>

import type {Shop} from "~/types/user";

const {shop} = defineProps<{
  shop: Shop
}>()

const onClick = async () => {
  useTrackEvent('install_banner_clicked', {shop_handle: shop.handle})
  const {$analytics} = useNuxtApp()
  $analytics.once(
      'trackEnd',
      async () => {
        await navigateTo('https://flypinstall.onelink.me/VCzv/download', {external: true})
      }
  )
}


onMounted(() => {
  useTrackEvent('install_banner_viewed', {
    seller_handle: shop.handle
  })
})
</script>